import {
    handleEmailError,
    handleNumbersError,
    handleRequiredError,
    handleWebsiteError
} from '../../utils';

export const getFormModel = (data?: any) => {
    return {
        COMPDES: {
            value: data?.COMPDES || '',
            error: '',
            validationRules: [handleRequiredError]
        },
        VATNUM: {
            value: data?.VATNUM || '',
            error: '',
            validationRules: [handleRequiredError]
        },
        EXTFILENAME: {
            value: data?.EXTFILENAME || {Data: null},
            error: ''
        },
        ADDRESS: {
            value: data?.ADDRESS || '',
            error: '',
            validationRules: [handleRequiredError]
        },
        EMAIL: {
            value: data?.EMAIL || '',
            error: '',
            validationRules: [handleEmailError]
        },
        STATEB: {
            value: data?.STATEB || '',
            error: '',
            validationRules: [handleRequiredError]
        },
        COUNTRYNAME: {
            value: data?.COUNTRYNAME || '',
            error: '',
            validationRules: [handleRequiredError]
        },
        STATENAME: {
            value: data?.STATENAME || '',
            error: '',
            validationRules: []
        },
        ZIP: {
            value: data?.ZIP || '',
            error: ''
        },
        WEBSITE: {
            value: data?.WEBSITE || '',
            error: '',
            validationRules: [handleWebsiteError]
        },
        PHONE: {
            value: data?.PHONE || '',
            error: '',
            validationRules: [handleRequiredError, handleNumbersError]
        }
    };
};
